// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrafficconfigGcpStatus } from './TrafficconfigGcpStatus';
import {
  TrafficconfigGcpStatusFromJSON,
  TrafficconfigGcpStatusFromJSONTyped,
  TrafficconfigGcpStatusToJSON,
  TrafficconfigGcpStatusToJSONTyped,
} from './TrafficconfigGcpStatus';
import type { TrafficconfigAzureStatus } from './TrafficconfigAzureStatus';
import {
  TrafficconfigAzureStatusFromJSON,
  TrafficconfigAzureStatusFromJSONTyped,
  TrafficconfigAzureStatusToJSON,
  TrafficconfigAzureStatusToJSONTyped,
} from './TrafficconfigAzureStatus';
import type { GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType } from './GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType';
import {
  GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeFromJSON,
  GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeFromJSONTyped,
  GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeToJSON,
  GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeToJSONTyped,
} from './GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType';
import type { TrafficconfigAwsStatus } from './TrafficconfigAwsStatus';
import {
  TrafficconfigAwsStatusFromJSON,
  TrafficconfigAwsStatusFromJSONTyped,
  TrafficconfigAwsStatusToJSON,
  TrafficconfigAwsStatusToJSONTyped,
} from './TrafficconfigAwsStatus';

/**
 *
 * @export
 * @interface TrafficconfigTrafficConfigStatus
 */
export interface TrafficconfigTrafficConfigStatus {
  /**
   *
   * @type {TrafficconfigAwsStatus}
   * @memberof TrafficconfigTrafficConfigStatus
   */
  awsStatus?: TrafficconfigAwsStatus;
  /**
   *
   * @type {TrafficconfigAzureStatus}
   * @memberof TrafficconfigTrafficConfigStatus
   */
  azureStatus?: TrafficconfigAzureStatus;
  /**
   *
   * @type {string}
   * @memberof TrafficconfigTrafficConfigStatus
   */
  dnsDomain?: string;
  /**
   *
   * @type {TrafficconfigGcpStatus}
   * @memberof TrafficconfigTrafficConfigStatus
   */
  gcpStatus?: TrafficconfigGcpStatus;
  /**
   *
   * @type {GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType}
   * @memberof TrafficconfigTrafficConfigStatus
   */
  privateTraffic?: GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType;
  /**
   *
   * @type {GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType}
   * @memberof TrafficconfigTrafficConfigStatus
   */
  publicTraffic?: GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusType;
}

/**
 * Check if a given object implements the TrafficconfigTrafficConfigStatus interface.
 */
export function instanceOfTrafficconfigTrafficConfigStatus(
  value: object,
): value is TrafficconfigTrafficConfigStatus {
  return true;
}

export function TrafficconfigTrafficConfigStatusFromJSON(
  json: any,
): TrafficconfigTrafficConfigStatus {
  return TrafficconfigTrafficConfigStatusFromJSONTyped(json, false);
}

export function TrafficconfigTrafficConfigStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigTrafficConfigStatus {
  if (json == null) {
    return json;
  }
  return {
    awsStatus:
      json['aws_status'] == null
        ? undefined
        : TrafficconfigAwsStatusFromJSON(json['aws_status']),
    azureStatus:
      json['azure_status'] == null
        ? undefined
        : TrafficconfigAzureStatusFromJSON(json['azure_status']),
    dnsDomain: json['dns_domain'] == null ? undefined : json['dns_domain'],
    gcpStatus:
      json['gcp_status'] == null
        ? undefined
        : TrafficconfigGcpStatusFromJSON(json['gcp_status']),
    privateTraffic:
      json['private_traffic'] == null
        ? undefined
        : GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeFromJSON(
            json['private_traffic'],
          ),
    publicTraffic:
      json['public_traffic'] == null
        ? undefined
        : GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeFromJSON(
            json['public_traffic'],
          ),
  };
}

export function TrafficconfigTrafficConfigStatusToJSON(
  json: any,
): TrafficconfigTrafficConfigStatus {
  return TrafficconfigTrafficConfigStatusToJSONTyped(json, false);
}

export function TrafficconfigTrafficConfigStatusToJSONTyped(
  value?: TrafficconfigTrafficConfigStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws_status: TrafficconfigAwsStatusToJSON(value['awsStatus']),
    azure_status: TrafficconfigAzureStatusToJSON(value['azureStatus']),
    dns_domain: value['dnsDomain'],
    gcp_status: TrafficconfigGcpStatusToJSON(value['gcpStatus']),
    private_traffic:
      GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeToJSON(
        value['privateTraffic'],
      ),
    public_traffic:
      GithubComNeoTechnologyNeo4jCloudLibsDbingressApisDbingressNeo4jIoV1StatusTypeToJSON(
        value['publicTraffic'],
      ),
  };
}
